import { Typography } from '@rossum/ui/material';
import { VerticalContainer } from './VerticalContainer';

type SidebarItemLabelProps = {
  label: string;
  sublabel?: string;
  isRequired?: boolean;
};

export const SidebarItemLabel = ({
  label,
  sublabel,
  isRequired = false,
}: SidebarItemLabelProps) => {
  const labelNode = (
    <Typography
      variant="body2"
      color="text.secondary"
      whiteSpace="pre-wrap"
      sx={{
        overflowWrap: 'anywhere',
      }}
    >
      {label}
      {isRequired ? (
        <Typography
          lineHeight="inherit"
          fontSize="inherit"
          color="error"
          component="span"
        >
          *
        </Typography>
      ) : null}
    </Typography>
  );

  const sublabelNode = (
    <Typography
      variant="caption"
      color="text.secondary"
      whiteSpace="pre-wrap"
      sx={{
        overflowWrap: 'anywhere',
      }}
    >
      {sublabel}
    </Typography>
  );

  return (
    <VerticalContainer dense>
      {labelNode}
      {sublabel ? sublabelNode : null}
    </VerticalContainer>
  );
};
